export const drawerConf = {
    keys: { qId: 'qSkillDetailsId' },
    name: 'skill-details-drawer',
} as const;

export const qDrawerName = 'qDrawerName';
